export const Routes = {
  Login: '/',
  HomePage: '/home-page',
} as const;
